/**
 * Valor sentinela da lista de entrantes: "não há quem me renda, vou encerrar".
 *
 * Encerrar o plantão mora dentro do formulário de troca, e não num modal curto à
 * parte, porque quem larga a vigilância atesta o estado da barragem — tendo ou
 * não quem receba o turno. Encerrar sozinho é justamente quando ninguém confere
 * depois; pular o checklist nessa hora perde a única atestação que aquele turno
 * vai ter. GUPM-272 Rev.2.
 *
 * Não colide com id de operador: `operator_in_id` é uuid.
 *
 * Mora em arquivo próprio (e não no modal) porque o `<select>` que oferece a
 * opção vive em `components/HandoverSections.tsx`, que o modal importa —
 * declarar lá criaria import circular.
 */
export const SEM_SUBSTITUTO = '__sem-substituto__';
